export default __webpack_public_path__ + "static/media/bwTheme-girl.c74f28ac.svg";